// Copyright 2020 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { Color } from "services/Color/Color";
import { NamedColor } from "services/Color/NamedColor";

export class HexColorToColorValueConverter implements IValueConverter<NamedColor, string> {
    public toView(value: string): NamedColor {
        return new NamedColor("", Color.fromHex(value));
    }

    public fromView(value: NamedColor): string {
        return value.color.hex;
    }
}
